var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoseRingL = function SvgNoseRingL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 32,
    viewBox: "0 0 0.54 0.62",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.16.05s.01.11.01.14c-.01.14.01.05-.1.1C.04.31.04.36.06.4m.18.16c.01.01.01.01.02.01C.28.57.49.44.49.33.49.27.39.27.36.26.35.23.36.08.34.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.12.45C.03.51.15.6.19.5.2.47.17.46.15.45.15.44.13.44.12.45zM.01.51C.01.47.03.42.08.38.1.37.12.37.15.37c.01 0 .03 0 .04.01L.2.39c.05.02.09.04.06.13C.24.59.19.61.15.62.12.62.08.61.06.59.03.57.02.54.01.51z",
    fill: "#000"
  })));
};

export default SvgNoseRingL;